import { get, postFormData } from '@/helpers/httpHandler';
import { Notification } from '@/modules/notifications/Notification';
import { cloneDeep } from 'lodash';

export default {
  getItemsList: ({ commit }, { params } = {}) => {
    return get('/notifications', {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  retrieve: (_, id) => get(`/notifications/${id}`),

  retrieveUserNotifications: (_, id) => get(`/users/${id}/notifications`),

  storeOrUpdate({ commit }, dataInput) {
    let url = dataInput.url;
    let data = dataInput.data;
    let translations = dataInput.translations;

    let recipientsQuantity = data.recipients.length + '';

    let formData = new FormData();
    formData.append('image', data.generalInformation.file || '');

    // dispatch time
    if (!data.generalInformation.chooseTime) {
      formData.append('dispatch_soon', true);
    } else {
      formData.append(
        'dispatch_time',
        Notification.setTimeCenter(data.generalInformation.dispatchTime).format(
          'YYYY-MM-DD HH:mm'
        )
      );
    }

    formData.append('translations', JSON.stringify(translations));
    formData.append('filter', JSON.stringify(data.filters));
    formData.append('recipients', JSON.stringify(data.recipients));
    formData.append('recipients_quantity', recipientsQuantity);

    commit('loading', true, { root: true });

    return postFormData(url, formData);
  }
};
